<template>
	<div
		data-testid="dropdownfk-component"
		class="container__dropdownfk"
	>
		<div
			class="container__dropdown__label"
			style="display: flex; gap: 0.25rem; align-items: center"
		>
			<label :for="id">{{ label }}</label>
			<slot />
		</div>
		<div
			:class="[
				'container__dropdown__component',
				{ 'without--border-bottom': openDropdown || value },
			]"
			@click="toggleDropdown"
		>
			<div
				v-show="isToShowSelectedOption"
				:ref="`ref__dropdownfk__selected__option__${uniqueRef}`"
			>
				<div
					class="container__dropdownfk__list__options__item"
					:class="{ disabled: disabled }"
				>
					<div
						v-for="(value, propertieName, key) in selectedObject"
						:id="key"
						:key="key"
						:data-testid="key"
					>
						<div v-if="!isPropertieIdOrFk(propertieName)">
							<label class="container__dropdownfk__list__options__item__field">
								{{ `${propertieName}: ` }}
							</label>
							<label>
								{{ value }}
							</label>
						</div>
					</div>
				</div>
			</div>
			<div
				v-show="!isToShowSelectedOption"
				:ref="`ref__dropdownfk__text__filter__${uniqueRef}`"
				class="container__dropdown__component__withoutvalue"
				data-testid="container-dropdown-component-withoutvalue"
			>
				<input
					:id="id"
					:ref="`ref__dropdownfk__input__${uniqueRef}`"
					v-model="textFilter"
					type="text"
					class="container__dropdownfk__input"
					:placeholder="label || placeholder"
				/>
				<i class="fas fa-search icon emptyInput" />
			</div>
			<div
				:ref="`ref__dropdownfk__options__${uniqueRef}`"
				v-closable="{
					exclude: [
						`ref__dropdownfk__selected__option__${uniqueRef}`,
						`ref__dropdownfk__text__filter__${uniqueRef}`,
					],
					handler: 'closeDropdown',
				}"
				data-testid="dropdownfk-options-list"
				:class="['container__dropdownfk__list__options', { 'open--dropdown': openDropdown }]"
				@scroll="handleScroll($event)"
			>
				<div
					class="container__dropdownfk__list__options__item"
					@click="setValue('')"
				>
					<p>{{ $t('selectAnOption') }}</p>
				</div>
				<div
					v-for="(dropdownObject, key) in dropdownFiltred"
					:key="key"
					:data-testid="`dropdown_option_${key}`"
					:class="[
						'container__dropdownfk__list__options__item',
						{ blocked: hasBlockedItems && dropdownObject[blockPropertie] },
					]"
				>
					<div
						v-for="(value, propertieName, key) in dropdownObject"
						:key="key"
						@click="
							!(hasBlockedItems && dropdownObject[blockPropertie]) && setValue(dropdownObject.id)
						"
					>
						<div v-if="!isPropertieIdOrFk(propertieName)">
							<label class="container__dropdownfk__list__options__item__field">
								{{ `${propertieName}: ` }}
							</label>
							<label>
								{{ value }}
							</label>
						</div>
					</div>
					<div
						v-if="hasBlockedItems && dropdownObject[blockPropertie]"
						style="margin-top: 1rem"
					>
						<label>
							{{ blockReason }}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import _ from 'lodash'

export default {
	data() {
		return {
			/**
			 * Posicao atual do scroll
			 */
			lastIndex: 20,
			/**
			 * Seta se o dropdown deve estar ou nao ativo
			 */
			openDropdown: false,
			/**
			 * Seta o filtro que deve ser aplicado no dropdown
			 */
			textFilter: '',
		}
	},

	computed: {
		/**
		 * Filtro do dropdown
		 */
		dropdownFiltred() {
			if (this.dropdownOptions?.length > 0) {
				const textFilter = this.textFilter.toLowerCase()
				const columns = Object.keys(this.dropdownOptions[0]).filter((column) => column !== 'id')

				/**
				 * Realizar o filtro de acordo com o que foi digitado
				 */
				const result = this.dropdownOptions.filter((item) => {
					const model = _.pick(item, columns)
					const atualModel = Object.values(model).join(' ')
					return atualModel.toLowerCase().includes(textFilter)
				})

				return result.slice(0, this.lastIndex)
			}

			return []
		},
		/**
		 * Retorna se deve ou nao mostrar o input para filtrar o dropdown
		 */
		isToShowSelectedOption() {
			return this.value && !this.openDropdown
		},
		/**
		 * Objeto que esta selecionado atualmente
		 */
		selectedObject: function () {
			return this.dropdownOptions?.find((dropdown) => dropdown.id === this.value)
		},
		/**
		 * Retorna um Guid para o componente ter como referencia
		 * um valor unico por componente
		 */
		uniqueRef() {
			return uuidv4()
		},
	},
	methods: {
		/**
		 * Fecha o dropdown, usado no v-closeble
		 */
		closeDropdown() {
			this.openDropdown = false
			this.textFilter = ''
		},
		/**
		 * Evento para quando fizer scrool no dropdown
		 */
		handleScroll(event) {
			if (event.target.scrollTop + 30 > event.target.scrollHeight - event.target.offsetHeight) {
				this.lastIndex += 20
			}
		},
		/**
		 * Verifica se uma propriedade e um id ou fk
		 * para não exibir nenhum id ou fk na hora de listar os objetos
		 */
		isPropertieIdOrFk(propertieName) {
			return (
				propertieName === 'id' ||
				propertieName.startsWith('fk_') ||
				propertieName === this.blockPropertie ||
				this.hiddenProperties.includes(propertieName)
			)
		},
		/**
		 * Seta o valor do id que foi selecionado
		 */
		setValue: function (id) {
			this.$emit('input', id)
			if (this.clickListener) this.clickListener()
		},
		/**
		 * Fecha e abre o dropdown
		 */
		toggleDropdown: function () {
			if (!this.disabled) {
				if (this.openDropdown) {
					this.openDropdown = false
					this.$refs[`ref__dropdownfk__input__${this.uniqueRef}`].blur()
				} else {
					this.openDropdown = true
					this.lastIndex = 20
					this.textFilter = ''
					this.$refs[`ref__dropdownfk__options__${this.uniqueRef}`].scrollTop = 0
					this.$nextTick(() => this.$refs[`ref__dropdownfk__input__${this.uniqueRef}`].focus())
				}
			}
		},
	},
	props: {
		placeholder: {
			type: String,
		},
		id: {
			type: String,
			required: false,
			default: `dropdown_fk_${uuidv4()}`,
		},
		/**Propriedades a serem escondidas no dropdown */
		hiddenProperties: {
			type: Array,
			required: false,
			default: () => [],
		},
		/**
		 * Label que fica em cima do dropdown
		 */
		label: String,
		/**
		 * Valor que fará o bind com v-model
		 */
		value: {
			type: String,
			default: undefined,
		},
		/**
		 * Opcoes para o dropdown
		 */
		dropdownOptions: {
			type: Array,
			validator(value) {
				const valid = value.map((m) => Object.keys(m)).every((e) => e.includes('id'))

				if (!valid) {
					console.warn(
						"😯 Objetos da lista de opções devem conter um atributo 'id'. prop: dropdownOptions",
					)
				}

				return valid
			},
		},
		/**
		 * habilita/desabilita o dropdown
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Executar algum metodo para quando clicar em alguma opcao
		 */
		clickListener: {
			type: Function,
		},
		/**
		 * Propriedade para identificar se o componente tem itens que podem ser bloqueados de selecao
		 */
		hasBlockedItems: {
			type: Boolean,
			default: false,
		},
		/**
		 * Define qual a propriedade que valida se deve estar bloqueada ou nao de click
		 */
		blockPropertie: {
			type: String,
		},
		/**
		 * Qual o motivo como mensagem da opcao estar bloqueada
		 */
		blockReason: {
			type: String,
		},
	},
}
</script>

<style>
.container__dropdownfk {
	display: flex;
	flex-direction: column;
}

.container__dropdown__label {
	color: var(--color-navy-blue);
	font-weight: 400;
	font-size: 0.8rem;
	margin-bottom: 0.31rem;
}

.container__dropdown__component {
	position: relative;
	border: 1px solid var(--color-gray);
	border-radius: 4px;
}

.container__dropdown__component.without--border-bottom {
	border-bottom: none;
}

.container__dropdown__component__withoutvalue {
	display: flex;
	align-items: center;
}

.container__dropdown__component__withoutvalue i {
	color: rgb(var(--color-default));
	font-size: 0.9rem;
}

.container__dropdownfk__input {
	border: none;
	width: 100%;
	height: 100%;
	font-size: 0.75rem;
	padding: 0.5rem;
	font-family: 'Open Sans', sans-serif;
	background-color: transparent;
}

.container__dropdownfk__input::placeholder {
	color: #ccc;
}

.container__dropdownfk__input:focus {
	outline: none;
}

.container__dropdownfk__input:focus::placeholder {
	color: #888;
}

.container__dropdownfk__list__options {
	position: absolute;
	top: 1.7rem;
	left: -0.05rem;
	background-color: white;
	width: 100%;
	z-index: 20;
	max-height: 0;
	overflow: hidden;
	transition: max-height 0.1s ease-in-out;
}

.container__dropdownfk__list__options.open--dropdown {
	max-height: 15rem;
	overflow-y: auto;
	border-left: 1px solid var(--color-gray);
	border-right: 1px solid var(--color-gray);
	border-bottom: 1px solid var(--color-gray);
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.container__dropdownfk__list__options__item {
	display: flex;
	flex-direction: column;
	padding: 0.4rem 1rem;
	border-bottom: 1px solid var(--color-gray);
	color: rgb(var(--color-primary));
	font-size: 0.75rem;
}

.container__dropdownfk__list__options__item.disabled {
	background-color: rgba(var(--color-primary), 0.05);
}

.container__dropdownfk__list__options__item:hover {
	background-color: rgba(var(--color-primary), 0.05);
}

.container__dropdownfk__list__options__item:hover,
.container__dropdownfk__list__options__item:hover label {
	cursor: pointer;
}

.container__dropdownfk__list__options__item.blocked {
	color: var(--color-gray);
}

.container__dropdownfk__list__options__item.blocked:hover,
.container__dropdownfk__list__options__item.blocked:hover label {
	cursor: not-allowed;
	background-color: white;
}

.container__dropdownfk__list__options__item__field {
	font-weight: 700;
}
</style>
